import React, { Component } from 'react';
import { Label } from 'react-bootstrap';
import SearchBox from 'components/site/SearchBox';
import LocationStore from 'stores/LocationStore';
import LocationActionCreators from 'actions/LocationActionCreators';
import _ from 'lodash';
import { titleize } from 'underscore.string';
import Geosuggest from 'react-geosuggest';

const roleStyles = {
  Address: 'success',
};

function getLocationValue(item) {
  return titleize(item.optimized_name);
}

export default class LocationSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locations: [],
			filters: {
				page: 1,
				per_page: 10,
				paginate: true,
				sort_by: "_id",
			},
			isLoading: false
    };
    this.handleSearch = _.debounce(this.handleSearch, 500);
  }

  componentDidMount() {
    LocationStore.addChangeListener(this.handleLocationStoreChange);
  }

  componentWillUnmount() {
    LocationStore.removeChangeListener(this.handleLocationStoreChange);
    LocationStore.clearLocations();
  }

  handleLocationStoreChange = () => {
    const locations = LocationStore.getLocationSearchResults();
    this.setState({ locations, isLoading: false });
  }

  clear() {
    this.setState({ locations: [] });
  }

  handleChange(nGram) {
		this.setState({ isLoading: true }, () => {
			const filters = this.state.filters;
			filters.search = nGram;
			this.setState({ filters });
		})

  }

  handleSearch(nGram) {
    LocationActionCreators.findLocations(this.state.filters);
  }

  handleLocationSelect(value, item) {
    this.props.handleLocationSearch(item)
  }

	handleSuggestList(suggests) {
		console.log("SUGGESTS", suggests);
	}

  renderItem(item) {
		return (
			<div className="text-sm">
				<a
					className={`locationDetails${item._type} list-group-item`}
					style={{ cursor: 'pointer' }}
					key={item.value}
				>
					<p className="list-group-item-heading">
						<Label bsStyle={roleStyles[item._sub_type]}>{item._sub_type}</Label>&nbsp;
						<span className="searchName"><b>{item.name}</b> {item.address}</span>
					</p>
				</a>
			</div>
		);
	}

	render() {
		return (
			<div>
				<SearchBox
					items={this.state.locations}
					clear={() => this.clear()}
					search={nGram => this.handleSearch(nGram)}
					placeholder={this.props.placeholder}
					defaultValue={this.props.defaultValue}
					onChange={value => this.handleChange(value)}
					onSelect={(value, item) => this.handleLocationSelect(value, item)}
					getItemValue={this.props.displayValue || getLocationValue}
					renderItem={this.renderItem}
					inputStyle={this.props.inputStyle}
					showEmptyMessage={this.props.showEmptyMessage && !this.state.isLoading}
					emptyMessage={this.props.emptyMessage}
				/>
			</div>
		);
  }
}
